<div class="chat-modal-top">
    <div class="chat-modal-avatar-holder">
        <app-avatar
            [user]="recipient"
            [fontSize]="'12px'"
            [fontWeight]="'600'"
            [showIcons]="false">
        </app-avatar>
    </div>
    <div class="chat-modal-name-holder">
        <div class="chat-modal-name">{{ recipient.firstname }} {{ recipient.surname }}</div>
        <div class="chat-modal-online-status">{{ isOnline ? 'Online' : 'Offline' }}</div>
    </div>
    <div
        class="chat-modal-arrow-icon"
        (click)="enlargeChat()">
        <img src="assets/images/chat/arrow-into-square.svg" />
    </div>
    <div
        class="chat-modal-close-icon"
        (click)="onCloseClick()">
        <img src="assets/images/icon-menu-close.svg" />
    </div>
</div>
<div
    class="chat-modal-messages"
    #scrollPanel>
    <div
        class="chat-modal-day-messages"
        *ngFor="let messagesGroup of messagesGroups | keyvalue">
        <div class="chat-modal-date">{{ getFormattedDate(messagesGroup.key) }}</div>

        <app-chat-modal-message
            *ngFor="let message of messagesGroup.value"
            [message]="message">
        </app-chat-modal-message>
    </div>
</div>
<div
    class="chat-modal-bottom"
    [ngClass]="{ 'chat-modal-bottom--advanced': advancedMode }">
    <app-chat-editor
        *ngIf="advancedMode"
        [openedChat]="openedChat"></app-chat-editor>
    <textarea
        *ngIf="!advancedMode"
        [formControl]="content"
        placeholder="Enter Message"></textarea>
    <div
        *ngIf="!advancedMode"
        class="chat-modal-buttons-holder">
        <button
            class="btn btn-styled--secondary btn-block btn-select"
            type="button"
            (click)="onCloseClick()">
            Close
        </button>
        <button
            class="btn btn-styled btn-block btn-select"
            type="button"
            [disabled]="!sendAllowed"
            (click)="send()">
            Send
        </button>
    </div>
</div>
